import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref } from 'vue';
import Qrcode from 'qrcode.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Qrcode',
  props: {
    value: String
  },
  setup(__props) {
    const level = ref('M');
    const renderAs = ref('svg');
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(Qrcode, {
        value: __props.value,
        level: level.value,
        renderAs: renderAs.value
      }, null, 8, ["value", "level", "renderAs"]);
    };
  }
});